unit ErrorListType;
{

/* Initial. */

}
interface

uses
  JS,
  ErrorType;

type
  TErrorArray = array of TErrorType;

  TErrorListType = class
    fErrorArray: TErrorArray;
  public
    property ErrorArray: TErrorArray read fErrorArray;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TErrorListType.Create(const String_JSON: String);
var JSArray_ListType: TJSArray;
    JSValue_Type: JSValue;
    ErrorType: TErrorType;
begin
  if (String_JSON <> '[]') and (String_JSON <> 'null') then
  begin
    JSArray_ListType := TJSArray(TJSJSON.parseobject(String_JSON));

    for JSValue_Type in JSArray_ListType do
    begin
      ErrorType := TErrorType.Create(TJSJSON.stringify(JSValue_Type));

      Insert(ErrorType, fErrorArray, High(fErrorArray));
    end;
  end;
end;

end.
